/* eslint-disable no-extra-boolean-cast */
import { Grid, Switch } from "@mui/material";
import MDBox from "components/Basics/MDBox";

const InputBoolean = ({
	label,
	value,
	onChange,
	disabled,
	error,
	item,
	InputProps = {},
	...rest
}) => {
	return (
		<Grid
			size="grow"
			sx={{
				flexBasis: "33.333%",
				minWidth: "33.333%"
			}}
		>
			<MDBox
				display="flex"
				justifyContent="space-between"
				alignItems="center"
				className="customSwitchContainer"
				onClick={e => {
					if (!disabled) {
						onChange(!Boolean(value));
					}
				}}
				{...InputProps}
				bgColor={disabled ? "light" : "white"}
			>
				<MDBox>
					<span>{label}</span>
				</MDBox>
				<MDBox>
					<Switch disabled={disabled} checked={Boolean(value)} />
				</MDBox>
			</MDBox>
		</Grid>
	);
};
export default InputBoolean;
